export const COLUMN_IDS = {
  creator: 'creator',
  clicks: 'clicks',
  impressions: 'impressions',
  posts: 'posts',
} as const;

export type CreatorsStatsColumnId =
  (typeof COLUMN_IDS)[keyof typeof COLUMN_IDS];

export const COLUMN_SIZES: Record<CreatorsStatsColumnId, number> = {
  [COLUMN_IDS.creator]: 180,
  [COLUMN_IDS.clicks]: 100,
  [COLUMN_IDS.impressions]: 110,
  [COLUMN_IDS.posts]: 100,
};

export const COLUMN_ID_TO_API_FIELD: Record<CreatorsStatsColumnId, string> = {
  creator: 'display_name',
  clicks: 'click_count',
  impressions: 'impression_count',
  posts: 'post_count',
};

export const API_FIELD_TO_COLUMN_ID: Record<string, CreatorsStatsColumnId> =
  Object.fromEntries(
    Object.entries(COLUMN_ID_TO_API_FIELD).map(([columnId, apiField]) => [
      apiField,
      columnId,
    ])
  ) as Record<string, CreatorsStatsColumnId>;

export const DEFAULT_SORT_WITH_CLICKS = '-click_count';
export const DEFAULT_SORT_WITHOUT_CLICKS = '-post_count';

/** @deprecated Prefer getDefaultCreatorsSort(hasClickTracking) */
export const DEFAULT_SORT = DEFAULT_SORT_WITH_CLICKS;

const CREATOR_SORTABLE_API_FIELDS = new Set([
  COLUMN_ID_TO_API_FIELD[COLUMN_IDS.clicks],
  COLUMN_ID_TO_API_FIELD[COLUMN_IDS.impressions],
  COLUMN_ID_TO_API_FIELD[COLUMN_IDS.posts],
]);

export function getDefaultCreatorsSort(hasClickTracking: boolean): string {
  return hasClickTracking
    ? DEFAULT_SORT_WITH_CLICKS
    : DEFAULT_SORT_WITHOUT_CLICKS;
}

export function normalizeCreatorsSort(
  sort: string | null,
  hasClickTracking: boolean
): string {
  const defaultSort = getDefaultCreatorsSort(hasClickTracking);

  if (!sort) {
    return defaultSort;
  }

  const field = sort.startsWith('-') ? sort.slice(1) : sort;
  if (!CREATOR_SORTABLE_API_FIELDS.has(field)) {
    return defaultSort;
  }

  if (
    field === COLUMN_ID_TO_API_FIELD[COLUMN_IDS.clicks] &&
    !hasClickTracking
  ) {
    return defaultSort;
  }

  return sort;
}
